// Icons of the v9 website design (Mila-Website-v9-product.html), as React components.
import type { SVGProps } from 'react';

type P = SVGProps<SVGSVGElement>;
const stroke = { fill: 'none', stroke: 'currentColor', strokeWidth: 2, strokeLinecap: 'round' as const, strokeLinejoin: 'round' as const };

/** Four-point sparkle. */
export const Sparkle = (p: P) => (
  <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true" {...p}><path d="M12 0C12.9 7.2 16.8 11.1 24 12 16.8 12.9 12.9 16.8 12 24 11.1 16.8 7.2 12.9 0 12 7.2 11.1 11.1 7.2 12 0Z" /></svg>
);

/** Arrow pointing forward in reading order (flips in Arabic via .rtl:-scale-x-100 on the caller, or `dir`). */
export const Arrow = ({ className = '', ...p }: P) => (
  <svg viewBox="0 0 24 24" aria-hidden="true" className={`rtl:-scale-x-100 ${className}`} {...stroke} {...p}><path d="M5 12h14M13 6l6 6-6 6" /></svg>
);
export const Chevron = ({ className = '', ...p }: P) => (
  <svg viewBox="0 0 24 24" aria-hidden="true" className={`rtl:-scale-x-100 ${className}`} {...stroke} strokeWidth={2.2} {...p}><path d="m9 6 6 6-6 6" /></svg>
);
export const ChevronDown = (p: P) => (
  <svg viewBox="0 0 24 24" aria-hidden="true" {...stroke} strokeWidth={2.2} {...p}><path d="m6 9 6 6 6-6" /></svg>
);
export const Close = (p: P) => (
  <svg viewBox="0 0 24 24" aria-hidden="true" {...stroke} strokeWidth={2.4} {...p}><path d="M6 6l12 12M18 6L6 18" /></svg>
);
export const MenuIcon = (p: P) => (
  <svg viewBox="0 0 24 24" aria-hidden="true" {...stroke} strokeWidth={2.2} {...p}><path d="M4 7h16M4 12h16M4 17h16" /></svg>
);
export const Pin = (p: P) => (
  <svg viewBox="0 0 24 24" aria-hidden="true" {...stroke} {...p}><path d="M12 21s7-6.2 7-11.5A7 7 0 0 0 5 9.5C5 14.8 12 21 12 21Z" /><circle cx="12" cy="9.5" r="2.5" /></svg>
);
export const Search = (p: P) => (
  <svg viewBox="0 0 24 24" aria-hidden="true" {...stroke} {...p}><circle cx="11" cy="11" r="6.5" /><path d="m16 16 4.5 4.5" /></svg>
);
export const Star = (p: P) => (
  <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true" {...p}><path d="m12 2.8 2.8 5.7 6.3.9-4.6 4.4 1.1 6.3L12 17.1l-5.6 3 1.1-6.3L2.9 9.4l6.3-.9L12 2.8Z" /></svg>
);
export const Users = (p: P) => (
  <svg viewBox="0 0 24 24" aria-hidden="true" {...stroke} {...p}><circle cx="9" cy="8" r="3.5" /><path d="M2.5 20a6.5 6.5 0 0 1 13 0M16 4.6a3.5 3.5 0 0 1 0 6.8M18.5 20a6.5 6.5 0 0 0-3-5.5" /></svg>
);
export const Clock = (p: P) => (
  <svg viewBox="0 0 24 24" aria-hidden="true" {...stroke} {...p}><circle cx="12" cy="12" r="9" /><path d="M12 7v5l3 2" /></svg>
);
export const Calendar = (p: P) => (
  <svg viewBox="0 0 24 24" aria-hidden="true" {...stroke} {...p}><rect x="3.5" y="5" width="17" height="15.5" rx="3" /><path d="M3.5 10h17M8 3v4M16 3v4" /></svg>
);
export const Check = (p: P) => (
  <svg viewBox="0 0 24 24" aria-hidden="true" {...stroke} strokeWidth={2.4} {...p}><path d="m5 12.5 4.5 4.5L19 7.5" /></svg>
);
export const Plus = (p: P) => (
  <svg viewBox="0 0 24 24" aria-hidden="true" {...stroke} strokeWidth={2.4} {...p}><path d="M12 5v14M5 12h14" /></svg>
);
export const Minus = (p: P) => (
  <svg viewBox="0 0 24 24" aria-hidden="true" {...stroke} strokeWidth={2.4} {...p}><path d="M5 12h14" /></svg>
);
export const Lock = (p: P) => (
  <svg viewBox="0 0 24 24" aria-hidden="true" {...stroke} {...p}><rect x="5" y="10.5" width="14" height="10" rx="2.5" /><path d="M8.5 10.5V8a3.5 3.5 0 0 1 7 0v2.5" /></svg>
);
export const Shield = (p: P) => (
  <svg viewBox="0 0 24 24" aria-hidden="true" {...stroke} {...p}><path d="M12 3 4.5 6v5.5c0 4.5 3.2 8.2 7.5 9.5 4.3-1.3 7.5-5 7.5-9.5V6L12 3Z" /><path d="m8.5 12 2.5 2.5 4.5-5" /></svg>
);
export const Gift = (p: P) => (
  <svg viewBox="0 0 24 24" aria-hidden="true" {...stroke} {...p}><rect x="3.5" y="8" width="17" height="4.5" rx="1" /><path d="M5 12.5V20h14v-7.5M12 8v12M12 8c-1.5-3.5-6-3.5-6-1s4.5 1 6 1ZM12 8c1.5-3.5 6-3.5 6-1s-4.5 1-6 1Z" /></svg>
);
export const Phone = (p: P) => (
  <svg viewBox="0 0 24 24" aria-hidden="true" {...stroke} {...p}><rect x="6.5" y="2.5" width="11" height="19" rx="2.5" /><path d="M11 18.5h2" /></svg>
);
export const Mail = (p: P) => (
  <svg viewBox="0 0 24 24" aria-hidden="true" {...stroke} {...p}><rect x="3" y="5" width="18" height="14" rx="2.5" /><path d="m4 7 8 6 8-6" /></svg>
);
export const PlayCircle = (p: P) => (
  <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true" {...p}><path d="M8 5.5v13l11-6.5-11-6.5Z" /></svg>
);
export const Apple = (p: P) => (
  <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true" {...p}><path d="M12.152 6.896c-.948 0-2.415-1.078-3.96-1.04-2.04.027-3.91 1.183-4.961 3.014-2.117 3.675-.546 9.103 1.519 12.09 1.013 1.454 2.208 3.09 3.792 3.039 1.52-.065 2.09-.987 3.935-.987 1.831 0 2.35.987 3.96.948 1.637-.026 2.676-1.48 3.676-2.948 1.156-1.688 1.636-3.325 1.662-3.415-.039-.013-3.182-1.221-3.22-4.857-.026-3.04 2.48-4.494 2.597-4.559-1.429-2.09-3.623-2.324-4.39-2.376-2-.156-3.675 1.09-4.61 1.09zM15.53 3.83c.843-1.012 1.4-2.427 1.245-3.83-1.207.052-2.662.805-3.532 1.818-.78.896-1.454 2.338-1.273 3.714 1.338.104 2.715-.688 3.559-1.701" /></svg>
);
export const GooglePlay = (p: P) => (
  <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true" {...p}><path d="M22.018 13.298l-3.919 2.218-3.515-3.493 3.543-3.521 3.891 2.202a1.49 1.49 0 0 1 0 2.594zM1.337.924a1.486 1.486 0 0 0-.112.568v21.017c0 .217.045.419.124.6l11.155-11.087L1.337.924zm12.207 10.065l3.258-3.238L3.45.195a1.466 1.466 0 0 0-.946-.179l11.04 10.973zm0 2.067l-11 10.933c.298.036.612-.016.906-.183l13.324-7.54-3.23-3.21z" /></svg>
);
export const Instagram = (p: P) => (
  <svg viewBox="0 0 24 24" aria-hidden="true" {...stroke} {...p}><rect x="3.5" y="3.5" width="17" height="17" rx="5" /><circle cx="12" cy="12" r="4" /><path d="M17.2 6.8h.01" /></svg>
);
export const TikTok = (p: P) => (
  <svg viewBox="0 0 24 24" aria-hidden="true" {...stroke} {...p}><path d="M20 8.2v3.6a8.6 8.6 0 0 1-4.6-1.7v5.1a5.6 5.6 0 1 1-6.6-5.5v3.7a2.1 2.1 0 1 0 3 1.8V3.5h3.6A4.8 4.8 0 0 0 20 8.2z" /></svg>
);
export const LinkedIn = (p: P) => (
  <svg viewBox="0 0 24 24" aria-hidden="true" {...stroke} {...p}><rect x="3.5" y="3.5" width="17" height="17" rx="4" /><path d="M8 11v5M8 8v.01M12 16v-5M16 16v-3a2 2 0 0 0-4 0" /></svg>
);
export const WhatsApp = (p: P) => (
  <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true" {...p}><path d="M12 2a10 10 0 0 0-8.6 15.1L2 22l5-1.3A10 10 0 1 0 12 2Zm0 18.2a8.2 8.2 0 0 1-4.2-1.2l-.3-.2-3 .8.8-2.9-.2-.3A8.2 8.2 0 1 1 12 20.2Zm4.5-6.1c-.2-.1-1.5-.7-1.7-.8s-.4-.1-.6.1-.7.8-.8 1-.3.2-.5.1a6.7 6.7 0 0 1-3.3-2.9c-.3-.4.3-.4.7-1.3.1-.2 0-.3 0-.4l-.8-1.8c-.2-.5-.4-.4-.6-.4h-.5a1 1 0 0 0-.7.3 3 3 0 0 0-.9 2.2 5.1 5.1 0 0 0 1.1 2.7 11.7 11.7 0 0 0 4.5 4c1.7.7 2.3.8 3.2.6a2.7 2.7 0 0 0 1.8-1.2 2.2 2.2 0 0 0 .1-1.2c0-.1-.2-.2-.4-.3Z" /></svg>
);
/** The Saudi riyal sign. */
export const Sar = (p: P) => (
  <svg viewBox="0 0 1124.14 1256.39" fill="currentColor" aria-hidden="true" {...p}>
    <path d="M699.62,1113.02h0c-20.06,44.48-33.32,92.75-38.4,143.37l424.51-90.24c20.06-44.47,33.31-92.75,38.4-143.37l-424.51,90.24Z" />
    <path d="M1085.73,895.8c20.06-44.47,33.32-92.75,38.4-143.37l-330.68,70.33v-135.2l292.27-62.11c20.06-44.47,33.32-92.75,38.4-143.37l-330.68,70.27V66.13c-50.67,28.45-95.67,66.32-132.25,110.99v403.35l-132.25,28.11V0c-50.67,28.44-95.67,66.32-132.25,110.99v525.69l-295.91,62.88c-20.06,44.47-33.33,92.75-38.42,143.37l334.33-71.05v170.26l-358.3,76.14c-20.06,44.47-33.32,92.75-38.4,143.37l375.04-79.7c30.53-6.35,56.77-24.4,73.83-49.24l68.78-101.97v-.02c7.14-10.55,11.3-23.27,11.3-36.97v-149.98l132.25-28.11v270.4l424.53-90.28Z" />
  </svg>
);

// The design's occasion icons (birthday cake, graduation cap, heart, trophy) and the regular-booking table.
const OCC_PATHS: Record<string, string> = {
  birthday: 'M4 20h16 M5 20v-7h14v7 M5 16c1.2 1 2.3 1 3.5 0s2.3-1 3.5 0 2.3 1 3.5 0 2.3-1 3.5 0 M12 13V9.5 M12 7c.9-.9.9-1.8 0-2.7-.9.9-.9 1.8 0 2.7z',
  graduation: 'M2.5 9.5L12 5l9.5 4.5L12 14 2.5 9.5z M6.5 11.5V16c1.5 1.5 3.5 2.2 5.5 2.2s4-.7 5.5-2.2v-4.5 M21.5 9.5V15',
  anniversary: 'M12 20s-7.5-4.6-7.5-10.2A4.3 4.3 0 0 1 12 7.3a4.3 4.3 0 0 1 7.5 2.5C19.5 15.4 12 20 12 20z',
  achievement: 'M8 4h8v5a4 4 0 0 1-8 0V4z M8 5.5H5V7a3 3 0 0 0 3 3 M16 5.5h3V7a3 3 0 0 1-3 3 M12 13v4 M8.5 20h7 M9.5 17h5v3h-5z',
  regular: 'M4 9h16 M6 9v10 M18 9v10 M9 9l-1-4h8l-1 4',
};
export const OccasionIcon = ({ kind, ...p }: P & { kind: string }) => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.9} strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" {...p}>
    <path d={OCC_PATHS[kind] || OCC_PATHS.regular} />
  </svg>
);
